import { useState } from "react";
import ModalDialog from "../../common/ModalDialog";
import { ProductsPanel } from "../order/ProductsPanel";
import { ProjectBundleModel, ProjectBundleModelMapper } from "../../../models/project/ProjectBundleModel";
import { QuestionDialog } from "../../common/QuestionDialog";

export const BundleEditor = ({
  bundle,
  onClose,
  onSaveBundle,
}: {
  bundle?: ProjectBundleModel;
  onClose: () => void;
  onSaveBundle: (oldBundle: ProjectBundleModel | undefined, newBundle: ProjectBundleModel) => void;
}) => {
  const [newBundle, setNewBundle] = useState<ProjectBundleModel>(bundle || ProjectBundleModelMapper.createEmptyObject());
  const [closeClicked, setCloseClicked] = useState(false);

  return (
    <ModalDialog title={newBundle?.name} visible onClose={() => setCloseClicked(true)}>
      <div>
        {closeClicked && <QuestionDialog question="Lagre endringer?" answers={[{text: "Ja", color: "red"}, {text: "Nei", color: "green"}, {text: "Avbryt", default: true}]} onAnswerClicked={(answer) => {
            if(answer === "Ja") {
                onSaveBundle(bundle, newBundle);
                onClose();
            } else if(answer === "Nei") {
                onClose();
            } else if(answer === "Avbryt") {
                setCloseClicked(false);
            }
        }} />}
        <div className="flex mt-8 mb-12">
          <label className="my-auto">Ny produktgruppe navn:</label>
          <input
            className="ml-4 rounded-md p-1 text-black"
            type="text"
            value={newBundle.name}
            onInput={(e) => {
              setNewBundle({ ...newBundle, name: e.currentTarget.value });
            }}
          />
        </div>
        <ProductsPanel
          products={newBundle.products || []}
          addProduct={(product) => {
            setNewBundle({ ...newBundle, products: [...newBundle?.products, product] });
          }}
          removeProduct={() => {}}
          edit
        />
      </div>
    </ModalDialog>
  );
};
